
import { motion } from 'framer-motion';

const ContactInfo = () => {
  const contactCards = [
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      content: 'info.trackverse@gmail.com',
      description: 'Send us an email anytime',
      link: 'mailto:info.trackverse@gmail.com',
      buttonText: 'Send Email',
      color: 'bg-primary-blue',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      content: 'Building F, 18 Boulevard Tino Rossi, 20000 Ajaccio',
      description: 'Come visit our office',
      link: 'https://maps.google.com/?q=Building+F+18+Boulevard+Tino+Rossi+20000+Ajaccio',
      buttonText: 'Get Directions',
      color: 'bg-primary-green',
    },
    {
      icon: 'ri-time-line',
      title: 'Business Hours',
      content: 'Monday - Saturday',
      description: '8:00 AM - 7:00 PM',
      link: '#contact-form',
      buttonText: 'Schedule Call',
      color: 'bg-primary-blue',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {contactCards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl p-8 border border-gray-200 hover:border-primary-blue hover:shadow-lg transition-all group"
            >
              <div className={`w-16 h-16 flex items-center justify-center ${card.color} rounded-xl mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${card.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{card.title}</h3>
              <p className="text-gray-700 font-medium mb-2">{card.content}</p>
              <p className="text-gray-500 text-sm mb-6">{card.description}</p>
              <a
                href={card.link}
                target={card.link.startsWith('http') ? '_blank' : undefined}
                rel={card.link.startsWith('http') ? 'noopener noreferrer nofollow' : undefined}
                className="inline-flex items-center text-primary-blue font-semibold hover:text-primary-green transition-colors whitespace-nowrap cursor-pointer"
              >
                {card.buttonText}
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
